import type { PortalVersion } from './portalVersion';

const menuPaths: Record<string, string> = {
  release: '/delivery/release-workbench',
  services: '/delivery/service-view',
  record: '/delivery/release-record',
};

export const getDeliveryMenuSelection = (pathname: string): string[] | undefined => {
  const match = pathname.match(/^\/delivery\/(?:ci|cd)\/(release|services|record)\/?$/);
  const path = match ? menuPaths[match[1]] : pathname.replace(/\/$/, '');
  return Object.values(menuPaths).includes(path) ? [path] : undefined;
};

export const getPortalSwitchLocation = (
  pathname: string,
  search: string,
  version: PortalVersion,
) => {
  const params = new URLSearchParams(search);
  params.delete('v2');
  params.delete('legacy');
  let nextPath = pathname;
  if (version === 'classic' && /^\/delivery\/(release-workbench|workbench)\/?$/.test(pathname)) {
    // The standalone workbench is the CD entry; CI keeps its own historical route.
    nextPath = '/delivery/cd/release';
  }
  return { pathname: nextPath, search: params.toString() };
};
